
import { mapGetters, mapActions } from "vuex"
import pick from "lodash/pick"
import capitalize from "lodash/capitalize"
import filtersMixin from "@/mixins/filters"

export default {
  mixins: [filtersMixin],

  layoutProps: {
    titleToken: "participants.title",
  },

  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  data () {
    return {
      countries: [],
      participants: [],
      isMeetingModalOpen: false,
      meetingModalUser: null,
      checkboxFilters: ["favorite"],
      toastIntervalId: null,
      toastCounter: 0,
    }
  },

  computed: {
    ...mapGetters("tags", { getTagsOptions_: "getOptions" }),
    activitySpheresOptions () {
      return this.getTagsOptions_(this.$i18n, this.$fmt.localize,
        { key: "activitySpheres", withOther: false })
    },
    industriesOptions () {
      return this.getTagsOptions_(this.$i18n, this.$fmt.localize,
        { key: "industries", withOther: false })
    },
    interestsOptions () {
      return this.getTagsOptions_(this.$i18n, this.$fmt.localize,
        { key: "interests", withOther: false })
    },
    countriesOptions () {
      const picked = pick(this.$t("geo.countries"), this.countries)
      const entries = Object.entries(picked)
      const result = entries.sort((a, b) => a[1].localeCompare(b[1]))
      return Object.fromEntries(result)
    },
  },

  async mounted () {
    this.fetchTags()
    this.fetchCountries()
    this.fetchFavoriteUsers()

    if (this.$auth.loggedIn) {
      await this.$nextTick()
      const { showToast } = this
      showToast()
      this.toastIntervalId = setInterval(showToast, 1000 * 60 * 10)
    }
  },
  beforeDestroy () { clearInterval(this.toastIntervalId) },

  methods: {
    ...mapActions("tags", ["fetchTags"]),
    ...mapActions("user", ["fetchFavoriteUsers"]),

    async fetchCountries () {
      const [res, err] = await this.$api.user.getCountries()
      if (err) {
        console.error(err)
        return
      }
      this.countries = res || []
    },

    async filter () {
      const [res, err] = await this.$api.user.getUsers({
        params: {
          ...this.params,
          "paginator[limit]": 16,
          "sort[participationType]": "asc",
          [`sort[lastName${capitalize(this.$i18n.locale)}]`]: "asc",
        },
      })
      if (err) {
        console.error(err)
        return
      }
      this.participants = res?.list || []
      this.paginator = res?.paginator || {}
    },

    appointMeeting (user) {
      this.meetingModalUser = user
      this.isMeetingModalOpen = true
    },

    showToast () {
      const toast = this.$t("participants.toasts")[this.toastCounter % 2]
      this.$toast(toast)
      ++this.toastCounter
    },
  },
}
